import { useEffect, useState }  from "react";
import ApiVolumesTrims from '../../api/volumestrims';
import AddNewTrimSynonym from './AddNewTrimSynonym';
import ListWithControls from "../general/ListWithControls";
import { useDispatch } from "react-redux";

import { log as actionsLog } from "../../store/actions";

const { addToLog } = actionsLog;

const TrimsSynonyms = ({ selectedModel, selectedVolume, selectedTrim }) => {

    let dispatch = useDispatch();

    const [ trigger, setTrigger ] = useState(0);
    const [ items, setItems ] = useState([]);
    const [ selectedSynonym, setSelectedSynonym ] = useState(null);
    const [ synonymToRename, setSynonymToRename ] = useState(null);

    const selectSynonym = synonym => {
        setSelectedSynonym(synonym);
    };

    const renameSynonym = (e, synonym) => {
        e.stopPropagation();
        let proceed = window.confirm(`Rename synonym ${synonym.name} for ${selectedTrim.name} [${selectedTrim.id}] to ${synonymToRename.name}?`);
        if (proceed) {
            ApiVolumesTrims.updateSynonym({ idModel: selectedModel.id, idVolume: selectedVolume.id, idTrim: selectedTrim.id, oldName: synonym.name, newName: synonymToRename.name }).then(resp => {
                dispatch(addToLog(resp));
                setSynonymToRename(null);
                setTrigger(new Date());
            });
        }
    }

    const deleteSynonym = synonym => {
        let proceed = window.confirm(`Delete synonym: ${synonym.name} for model ${selectedTrim.name} [${selectedTrim.id}]?`);
        if (proceed) {
            ApiVolumesTrims.deleteSynonym({ idModel: selectedModel.id, idVolume: selectedVolume.id, idTrim: selectedTrim.id, name: synonym.name }).then(resp => {
                dispatch(addToLog(resp));
                setTrigger(new Date());
                if (selectedSynonym && selectedSynonym.id == synonym.id) {
                    setSelectedSynonym(null);
                }
            });
        }
    }

    useEffect(() => {
        ApiVolumesTrims.getSynonyms(selectedModel.id, selectedVolume.id, selectedTrim.id).then(json => {
            const synonymsAsObjects = json.synonyms.map(item => { return { id: item, name: item }});
            setItems(synonymsAsObjects); 
        });
    }, [selectedTrim, trigger]);

    const onSynonymAdded = () => {
        setTrigger(new Date());
    };

    return (
        selectedTrim && selectedTrim.id > -1 ?
        <div>
            <div className="border border-gray-700 mb-2">
                <div className="text-lg p-2 bg-gray-900">
                    Synonyms { selectedTrim.id > -1 ? "for " + selectedTrim.name : "" }
                </div>
                <ListWithControls 
                    items={items} 
                    selected={selectedSynonym} 
                    fxSelectItem={selectSynonym} 
                    fxRenameItem={renameSynonym}
                    fxDeleteItem={deleteSynonym}
                    itemToRename={synonymToRename}
                    fxSetItemToRename={setSynonymToRename} />
            </div>
            <AddNewTrimSynonym fxOnSynonymAdded={onSynonymAdded} selectedModel={selectedModel} selectedVolume={selectedVolume} selectedTrim={selectedTrim} />
        </div>
        :
        <div className="text-center p-2">Model not selected</div>
    );
}

export default TrimsSynonyms;